let CucaProductType;
(function (CucaProductType) {
  CucaProductType['RIPLEYPRODUCT'] = 'RIPLEYPRODUCT';
  CucaProductType['RIPLEYMRKTPRODUCT'] = 'RIPLEYMRKTPRODUCT';
  CucaProductType['RIPLEYCLUBESPRODUCT'] = 'RIPLEYCLUBESPRODUCT';
  CucaProductType['NONE_VALUE'] = '';
})(CucaProductType || (CucaProductType = {}));

module.exports = CucaProductType;
